import vfukColors from '@legacy-vfuk/core-theme-ws10/dist/constants/colors';

const colors = {
  mineShaft: '#333333',
  ...vfukColors,
};

export default colors;
